var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6c2cf5276fe8e93a67e5aa8f9956d9ce426d5713"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["squeeze-prd-vercel@squeeze-o2"]={id:"6c2cf5276fe8e93a67e5aa8f9956d9ce426d5713"};
      